const timeline = [
  {
    period: "2023 – 2027",
    degree: "B.Tech in Computer Science & Engineering",
    institution: "COER University",
    detail:
      "DSA, Web Dev, Machine Learning, DBMS and Operating Systems.",
    icon: "🎓",
  },
  {
    period: "2021",
    degree: "Higher Secondary (Class XII)",
    institution: "Doon Public School",
    detail: "Physics, Chemistry, Mathematics",
    icon: "📘",
  },
];

export default timeline;
